import React, { Component } from 'react';
import ReduxLazyScroll from 'redux-lazy-scroll';

import Loader from './loader';

import styles from '../styles/components/infinite-scroller.scss';

class InfiniteScroller extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingMore: false,
        };

        this.loadMore = this.loadMore.bind(this);
    }

    loadMore() {
        this.setState({
            loadingMore: true,
        });

        this.props.loadMore().then(() => {
            this.setState({ loadingMore: false });
        });
    }

    render() {
        return (
            <div className="posts-lazy-scroll">
                <ReduxLazyScroll
                    isFetching={this.state.loadingMore}
                    loadMore={this.loadMore}
                    hasMore={this.props.pageCount > this.props.currentPage}
                >
                    {this.props.children}
                </ReduxLazyScroll>
                {this.state.loadingMore && (
                    <div className={`${styles.scroller}`}>
                        <div className={`title-section text-center ${styles.scrollerTitle}`}>
                            <div>
                                <Loader displayLoader={this.state.loadingMore} size={20} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default InfiniteScroller;



/** WEBPACK FOOTER **
 ** ./src/components/shared/infinite-scroller.jsx
 **/